import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DownloadRequestService } from '@core/services/download-request.service';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-download-demographics-ratings2025',
    templateUrl: './download-demographics-ratings2025.component.html',
    styleUrls: ['./download-demographics-ratings2025.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DownloadDemographicsRatings2025Component implements OnInit {
  downloadService = inject(DownloadRequestService);
  dialog = inject(MatDialog);
  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {}

  downloadDemographics(searchValues: any) {
    this.downloadService
      .saveRequestForRatings2025(searchValues)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.displaySuccessMessage();
        }
      });
  }

  displaySuccessMessage() {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('downloads.requestSubmitted.title'),
          message: this.translocoService.translate(
            'downloads.requestSubmitted.message'
          ),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('downloads.requestSubmitted.okButton'),
          showCancel: false,
        },
      },
    };

    this.dialog.open(ConfirmationModalComponent, {
      data: modal,
    });
  }
}
